import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, CircularProgress, Alert, AlertTitle } from "@mui/material";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

let playerIsLoaded = false;

const Stream = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const user = useSelector((state) => state.auth.user);

  let height = 600;

  useEffect(() => {
    const updateHeight = () => {
      let body = document.body;
      let newHeight = 600;

      if (window.innerHeight) {
        newHeight = window.innerHeight;
      } else if (body.parentElement.clientHeight) {
        newHeight = body.parentElement.clientHeight;
      } else if (body && body.clientHeight) {
        newHeight = body.clientHeight;
      }

      height = newHeight - 150;
      if(document.getElementById("player-wrp-1")?.children?.length > 0){
        document.getElementById("player-wrp-1").children[0].style.height = height + "px";
        document.getElementById("player-wrp-1").children[0].style.width = "100%";
      }
      
      document.getElementById("player-wrp-1").width = "100%";
    };

    const loadPlayerScript = async () => {
      if (!playerIsLoaded) {
        playerIsLoaded = true;

        try {
          // Get the room value from the URL query parameters
          const roomValue = searchParams.get("room");
          console.log('Current user:', user);
          console.log('Room value:', roomValue);
          
          if (!user?.streams) {
            throw new Error("No streams available for user");
          }

          const streamConfig = user.streams.find((x) => x.id === roomValue);
          console.log('Found stream config:', streamConfig);
          
          if (!streamConfig) {
            throw new Error(`Stream configuration not found for room ${roomValue}`);
          }

          if (!streamConfig.streamURL) {
            throw new Error("Stream URL is missing in configuration");
          }

          const urlString = streamConfig.streamURL;
          const audioOnly = streamConfig.audioonly || false;
          const token = localStorage.getItem("session");
          
          if (!token) {
            throw new Error("No authentication token found");
          }

          const headers = {
            "Content-Type": "application/json",
            Authorization: "Basic " + token,
          };

          console.log('Making request with headers:', headers);
          const res = await axios.get("/api/streams/url", { headers });
          const url = res?.data?.url;
          console.log('Received stream URL:', url);

          if (!url) {
            throw new Error("Failed to get stream URL");
          }

          const finalStreamUrl = urlString + url;
          console.log('Final stream URL:', finalStreamUrl);

          console.log('Initializing player with config:', {
            reconnects: 150,
            container: "player-wrp-1",
            audio_only: audioOnly,
            stream_url: finalStreamUrl,
            buffering: 800,
            autoplay: true,
            muted: true,
            height: height,
            width: "100%",
            sync_buffer: 2000,
          });

          window.SLDP.init({
            reconnects: 150,
            container: "player-wrp-1",
            audio_only: audioOnly,
            stream_url: finalStreamUrl,
            buffering: 800,
            autoplay: true,
            muted: true,
            height: height,
            width: "100%",
            sync_buffer: 2000,
          });

          const playerWrapper = document.getElementById("player-wrp-1").parentElement;
          if (playerWrapper) {
            playerWrapper.style.alignItems = "center";
            playerWrapper.style.justifyContent = "center";
          }
          updateHeight();
          setIsLoading(false);
        } catch (err) {
          console.error('Error loading stream:', err);
          setError(err.message);
          setIsLoading(false);
        }
      }
    };

    const scriptLoaded = () => {
      updateHeight();
      loadPlayerScript();
    };

    // Attach resize event listener
    window.addEventListener("resize", updateHeight);

    if (!playerIsLoaded && user?.streams && searchParams.get("room")) {
      const script = document.createElement("script");
      script.src = "/sldp-v3.1.1.min.js";
      script.async = true;
      script.onload = scriptLoaded;

      document.body.appendChild(script);
    }

    return () => {
      // Remove resize event listener on component unmount
      window.removeEventListener("resize", updateHeight);
      console.log("Component unmounted");
    };
  }, [user, searchParams]);

  if (error) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
      >
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      </Box>
    );
  }

  //if (isLoading) {
  //  return (
  //    <Box 
  //      display="flex" 
  //      justifyContent="center" 
  //      alignItems="center" 
  //     height="100vh"
  //    >
  //      <CircularProgress size={60} />
  //    </Box>
  //  );
 // }

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box flex={1} style={{ minWidth: 300, width: "100%", alignItems: "center", justifyContent: "center" }}>
        <div id="player-wrp-1" className="player-wrp"></div>
      </Box>
    </Box>
  );
};

export default Stream;